import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import ActionBarItemWrapper from '../items/ActionBarItemWrapper';
import ActionBarButton from '../items/ActionBarButton';
/** Wraps it's children in ActionBarItemWrapper and ActionBarButton displaying
 *  the appropriate tooltip and, on click, redirecting to sisu depending on
 *  whether the current user is logged in. */
var ActionBarButtonRestriced = function (_a) {
    var restrictedActionName = _a.restrictedActionName, renderPopover = _a.renderPopover, tooltip = _a.tooltip, children = _a.children, buttonProps = __rest(_a, ["restrictedActionName", "renderPopover", "tooltip", "children"]);
    var t = useTranslation().t;
    var _b = useRestrictToLoggedIn(), isLoggedIn = _b.isLoggedIn, restrictToLoggedIn = _b.restrictToLoggedIn;
    var newPopover = isLoggedIn ? renderPopover : undefined;
    var newTooltip = isLoggedIn ? tooltip : t('actionbar.download.mustLogIn');
    var restrictedProps = { onClick: restrictToLoggedIn(restrictedActionName) };
    var newButtonProps = isLoggedIn ? buttonProps : restrictedProps;
    return (React.createElement(ActionBarItemWrapper, { tooltip: newTooltip, renderPopover: newPopover },
        React.createElement(ActionBarButton, __assign({}, newButtonProps), children)));
};
ActionBarButtonRestriced.displayName = 'ActionBarButtonRestriced';
export default ActionBarButtonRestriced;
//# sourceMappingURL=ActionBarButtonRestriced.js.map